import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/settings/')({
  component: () => <div>Hello</div>,
});
